import lib from '@/library'
import store from '@/store'
import Brands from '@/components/mixins/Brands'
import Vue from 'vue'

export default {
  mixins: [
    Brands
  ],

  computed: {
    statsAvailable () {
      return !lib.betting.event.isLive(this.event) &&
             !lib.betting.event.isResulted(this.event) &&
             !Vue._.isEmpty(this.homeStats) &&
             !Vue._.isEmpty(this.awayStats) &&
             !Vue._.isEmpty(this.awayEventStats) &&
             !Vue._.isEmpty(this.homeEventStats)
    },
    participantIds () {
      let result = lib.betting.event.getParticipantIds(this.event)

      if (this.selection && this.selection.idfoparticipant) {
        result.participantId = this.selection.idfoparticipant
      }

      return result
    },
    showParticipantStats () {
      return this.current_brand_cnfiguration.showParticipantStats
    },
    participantInfos () {
      return store.getters['bettingOfferState/getParticipantInfos']
    },
    homeParticipantInfo () {
      return this.findParticipantInfo('home')
    },
    awayParticipantInfo () {
      return this.findParticipantInfo('away')
    },
    homeStats () {
      return this.homeParticipantInfo.stats
    },
    awayStats () {
      return this.awayParticipantInfo.stats
    },
    homeEventStats () {
      return this.findEventsInfo('home')
    },
    awayEventStats () {
      return this.findEventsInfo('away')
    },
    stats () {
      return this.findParticipantInfo().stats
    },

    // Participant stats
    homeParticipantWins () {
      return this.homeStats.wins
    },
    homeParticipantLosses () {
      return this.homeStats.losses
    },
    homeParticipantTies () {
      if (this.event.idfosporttype.toUpperCase() !== 'NFL' || this.homeStats.ties === '0') return
      return this.homeStats.ties
    },
    homeParticipantOvertimeLosses () {
      if (this.event.idfosporttype.toUpperCase() !== 'ICE HOCKEY') return
      return this.homeStats.otl
    },
    awayParticipantWins () {
      return this.awayStats.wins
    },
    awayParticipantLosses () {
      return this.awayStats.losses
    },
    awayParticipantTies () {
      if (this.event.idfosporttype.toUpperCase() !== 'NFL' || this.awayStats.ties === '0') return
      return this.awayStats.ties
    },
    awayParticipantOvertimeLosses () {
      if (this.event.idfosporttype.toUpperCase() !== 'ICE HOCKEY') return
      return this.awayStats.otl
    },
    awayParticipantAgainstTheSpreadRecord () {
      return this.againstTheSpreadRecord('away')
    },
    homeParticipantAgainstTheSpreadRecord () {
      return this.againstTheSpreadRecord('home')
    },
    awayParticipantWinsAtAway () {
      return this.awayStats.wins_away
    },
    homeParticipantWinsAtHome () {
      return this.homeStats.wins_home
    },
    awayParticipantLossesAtAway () {
      return this.awayStats.losses_away
    },
    homeParticipantLossesAtHome () {
      return this.homeStats.losses_home
    },
    awayParticipantStatsWhenPlayingAway () {
      return this.awayParticipantWinsAtAway && this.awayParticipantLossesAtAway ? this.awayParticipantWinsAtAway + ' - ' + this.awayParticipantLossesAtAway : ''
    },
    homeParticipantStatsWhenPlayingHome () {
      return this.homeParticipantWinsAtHome && this.homeParticipantLossesAtHome ? this.homeParticipantWinsAtHome + ' - ' + this.homeParticipantLossesAtHome : ''
    },
    awayParticipantOverUnderRecord () {
      return this.overUnderRecord('away')
    },
    homeParticipantOverUnderRecord () {
      return this.overUnderRecord('home')
    },
    awayParticipantAveragePointsForPerGame () {
      return this.awayStats.points_for_average ? Math.round(this.awayStats.points_for_average) : ''
    },
    homeParticipantAveragePointsForPerGame () {
      return this.homeStats.points_for_average ? Math.round(this.homeStats.points_for_average) : ''
    },

    awayParticipantAveragePointsAgainstPerGame () {
      return this.awayStats.points_against_average ? Math.round(this.awayStats.points_against_average) : ''
    },
    homeParticipantAveragePointsAgainstPerGame () {
      return this.homeStats.points_against_average ? Math.round(this.homeStats.points_against_average) : ''
    },

    // Outright selection stats
    participantWins () {
      return this.stats.wins
    },
    participantLosses () {
      return this.stats.losses
    },
    participantTies () {
      if (this.event.idfosporttype.toUpperCase() !== 'NFL' || this.stats.ties === '0') return
      return this.stats.ties
    },
    participantOvertimeLosses () {
      if (this.event.idfosporttype.toUpperCase() !== 'ICE HOCKEY') return
      return this.stats.otl
    },

    // Against participant opponent stats
    awayParticipantWinProbability () {
      return this.awayEventStats.stats.win_probability
    },
    homeParticipantWinProbability () {
      return this.homeEventStats.stats.win_probability
    },
    // Pitcher stats
    awayParticipantPitcherRecord () {
      return this.checkPitcherName(this.event.awaypitchername, this.awayEventStats.stats['starting_pitcher.name']) ? this.awayEventStats.stats['starting_pitcher.record'] : ''
    },
    awayParticipantPitcherEra () {
      return this.checkPitcherName(this.event.awaypitchername, this.awayEventStats.stats['starting_pitcher.name']) ? this.awayEventStats.stats['starting_pitcher.era'] : ''
    },
    homeParticipantPitcherRecord () {
      return this.checkPitcherName(this.event.homepitchername, this.homeEventStats.stats['starting_pitcher.name']) ? this.homeEventStats.stats['starting_pitcher.record'] : ''
    },
    homeParticipantPitcherEra () {
      return this.checkPitcherName(this.event.homepitchername, this.homeEventStats.stats['starting_pitcher.name']) ? this.homeEventStats.stats['starting_pitcher.era'] : ''
    }
  },

  methods: {
    findParticipantInfo (side) {
      let result = {}

      if (this.participantIds) {
        let id = ''

        switch (side) {
          case 'home':
            if (this.participantIds && this.participantIds.participantHomeId) {
              id = this.participantIds.participantHomeId
            }
            break
          case 'away':
            if (this.participantIds && this.participantIds.participantAwayId) {
              id = this.participantIds.participantAwayId
            }
            break
          default:
            if (this.participantIds && this.participantIds.participantId) {
              id = this.participantIds.participantId
            }
        }

        if (id && Array.isArray(this.participantInfos)) {
          let info = this.participantInfos.find((info) => {
            return info.idfoparticipant === id
          })

          if (info) {
            result = info
          }
        }
      }

      if (!result.stats) result.stats = {}
      if (!result.eventsinfos) result.eventsinfos = []

      return result
    },

    findEventsInfo (side) {
      let result = {}
      let participantInfo = {}

      switch (side) {
        case 'home':
          participantInfo = this.homeParticipantInfo
          break
        case 'away':
          participantInfo = this.awayParticipantInfo
          break
        default:
      }

      let info = participantInfo.eventsinfos.find((info) => {
        return info.idfoevent === this.event.idfoevent
      })

      if (info) {
        result = info
      }

      if (!result.stats) result.stats = {}

      return result
    },

    checkPitcherName (mm2Name, thirdPartyName) {
      if (typeof mm2Name === 'string' && typeof thirdPartyName === 'string') {
        let mm2NameTransformed = [
          this.removeSpecialCharacters(mm2Name).toUpperCase(),
          this.transformToFirstLetterName(mm2Name)
        ]
        let thirdPartyNamesTransformed = [
          this.removeSpecialCharacters(thirdPartyName).toUpperCase(),
          this.transformToFirstLetterName(thirdPartyName)
        ]

        return Vue._.intersection(mm2NameTransformed, thirdPartyNamesTransformed).length > 0
      }

      return false
    },

    transformToFirstLetterName (phrase) {
      let words = phrase
      if (phrase.indexOf(' ') > -1) {
        words = phrase.split(' ')
        let firstLetterOfFirstName = words.shift().charAt(0)

        words.unshift(firstLetterOfFirstName)
        words = words.join('')
      }

      return this.removeSpecialCharacters(words).toUpperCase()
    },

    removeSpecialCharacters (phrase) {
      if (typeof phrase === 'string') {
        return phrase.replace(/\W/g, '')
      }

      return phrase
    },

    againstTheSpreadRecord (side) {
      let result = ''
      let stats = {}

      switch (side) {
        case 'home':
          stats = this.homeStats
          break
        case 'away':
          stats = this.awayStats
          break
        default:
      }

      let values = [
        stats.wins_vs_spread,
        stats.losses_vs_spread,
        stats.ties_vs_spread
      ]

      if (values.every((item) => Boolean(item))) {
        result = values.join(' - ')
      }

      return result
    },

    overUnderRecord (side) {
      let result = ''
      let stats = {}

      switch (side) {
        case 'home':
          stats = this.homeStats
          break
        case 'away':
          stats = this.awayStats
          break
        default:
      }

      let values = [
        stats.over_total,
        stats.under_total,
        stats.push_total
      ]

      if (values.every((item) => Boolean(item))) {
        result = values.join(' - ')
      }

      return result
    }
  },

  created () {

  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/ParticipantInfos.js